import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Navbar } from "react-bootstrap";
import { X, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import logo from "../../../assets/images/Logo smart farm1.jpg";
import { Store } from "../../../flux";
import "./SidebarMainNavbar.css";

const SidebarMainNavbar = ({
  handleToggleSidebar,
  collapsed = false,
  onToggleCollapse = () => {}
}) => {
    const [theme, setTheme] = useState(() => Store.getTheme());

    useEffect(() => {
      const onChange = () => setTheme(Store.getTheme());
      Store.addChangeListener(onChange);
      onChange();
      return () => Store.removeChangeListener(onChange);
    }, []);

    const isDark = theme === "dark";
    return (
      <div className="main-navbar smartfarm-sidebar-brand">
        <div
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
        >
          <Navbar.Brand
            className="w-100 mr-0 sidebar-brand-link"
            href="#"
          >
            <div className="d-table m-auto pt-3">
              <div className="sidebar-brand-logo-wrap">
                <img
                  id="main-logo"
                  className={`d-inline-block align-top mr-1 sidebar-brand-logo${isDark ? " sidebar-brand-logo--night" : ""}`}
                  src={isDark ? `${process.env.PUBLIC_URL || ""}/logo_nuit.png` : logo}
                  alt="Smart Farm"
                />
                <button
                  type="button"
                  className="toggle-sidebar d-sm-inline d-md-none d-lg-none mb-3"
                  onClick={handleToggleSidebar}
                  aria-label="Close navigation"
                >
                  <X className="toggle-sidebar-icon" aria-hidden="true" />
                </button>
              </div>
              {/*!hideLogoText && (
                <span className="d-none d-md-inline ml-1">Smart Farm</span>
              )*/}

            </div>
          </Navbar.Brand>
          <button
            type="button"
            className="sidebar-collapse-toggle d-none d-lg-inline-flex"
            onClick={(event) => {
              event.preventDefault();
              onToggleCollapse();
            }}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? (
              <PanelLeftOpen className="sidebar-collapse-toggle-icon" aria-hidden="true" />
            ) : (
              <PanelLeftClose className="sidebar-collapse-toggle-icon" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>
    );
};

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
  collapsed: PropTypes.bool,
  onToggleCollapse: PropTypes.func
};

export default SidebarMainNavbar;
